import Tab from "./Tab";
import axios from 'axios'

const tab = new Tab()

export default class Drawer
{
	constructor()
	{
		this._drawerInitElements = document.querySelectorAll(".jsDrawerInit");
		this._drawers = document.querySelectorAll(".jsDrawer");
		this._drawerClose = document.querySelectorAll(".jsDrawerClose");
		this._ajaxContent = document.getElementById("ajax-drawer-content")

		if (this._drawerInitElements) this.init();
	}

	openDrawer(drawer)
	{
		if (window.innerWidth > 1023) this.renderMask(drawer);
		drawer.classList.add('is-active')
		document.body.classList.add('state-drawer-open')

		if (parseInt(drawer.dataset.id, 10) === 0)
		{
			document.body.classList.add('state-drawer-give-open')
		}
	}

	closeDrawer(drawer)
	{
		if (window.innerWidth > 1023) this.hideMask(drawer);
		drawer.classList.remove('is-active');
		// history.pushState("#", document.title, window.location.pathname);
		document.body.classList.remove('state-drawer-open');
		document.body.classList.remove('state-drawer-give-open');

		// Remove the hash from the URL
		if (window.location.hash === "#giving" || window.location.hash === "#giving-monthly") {
			history.replaceState(null, null, " ");
		}		
	}

	renderMask(drawer)
	{
		drawer.nextSibling.nextSibling.classList.add("active");
	}

	hideMask(drawer)
	{
		drawer.nextSibling.nextSibling.classList.remove("active");
	}

	switchTab ()
	{
		tab.getContent(tab._tab[1], 1);
		tab.switchHeader(1)
	}

	switchDonateTab(btn)
	{
		this._drawers.forEach(drawer =>
		{
			if (drawer.dataset.id === btn.dataset.id)
			{
				switch (btn.dataset.initialTab)
				{
					case "single":
						drawer.querySelector(".jsTabSingle").click()
						break;
					case "monthly":
						drawer.querySelector(".jsTabMonthly").click()
						break;
				}
			}
		});
	}

	searchDrawer(type, i)
	{
		this._drawers.forEach(drawer =>
		{
			if (drawer.dataset.id === i.dataset.id)
			{
				switch (type)
				{
					case "OPEN":
						this.openDrawer(drawer);
						break;
					case "CLOSE":
						this.closeDrawer(drawer);
						break;
				}
			}
		});
	}

	ajax (url)
	{
		axios.get(url).then((response) =>
		{
			this._ajaxContent.innerHTML = `<div class="ajaxed-content">${response.data}</div>`
		})
	}

	init()
	{
		this._drawerInitElements.forEach(drawerInitEl =>
		{

			drawerInitEl.addEventListener("click", (event) =>
			{
				event.preventDefault()
				this.searchDrawer("OPEN", drawerInitEl);

				if (drawerInitEl.dataset.type === 'ajax')
				{
					this._ajaxContent.innerHTML = '<div></div>'
					this.ajax(drawerInitEl.href)
				}

				if (drawerInitEl.classList.contains("jsDonateSwitch"))
				{
					console.log('Switching drawer tabs');
					this.switchTab();
				}

				if (drawerInitEl.classList.contains("jsDonateSwitchTab"))
				{
					this.switchDonateTab(drawerInitEl);
				}
			});
		});

		this._drawerClose.forEach(drawerCloseElement =>
		{
			drawerCloseElement.addEventListener("click", (event) =>
			{
				event.preventDefault()
				this.searchDrawer("CLOSE", drawerCloseElement);
			});

		});
	}
}